<style scoped>
    /* .vertical .task-item{
		bottom:0;
        right:0;
		transition: bottom .1s linear;
	}
	.vertical.task-show>.task-item:nth-child(1){
		bottom: 8rem;
	}
	.vertical.task-show>.task-item:nth-child(2){
		bottom: 11.5rem;
		transition-delay: .1s;
	} */

    /* .horizontal .task-item{
		top:0;
        left: 100%;
		transition: left .1s linear;
	}
    .horizontal>.task-item:nth-child(1){
        top:4rem;
    }
    .horizontal.task-show>.task-item:nth-child(1){
        left: 0;
        transition-delay: .1s;
    }
    .horizontal>.task-item:nth-child(2){
        top:.5rem;
    }
    .horizontal.task-show>.task-item:nth-child(2){
        left: 0;
		top: .5rem;
	} */

    .task-item{
        left: 100%;
		transition: left .1s linear;
	}
    .task-show>.task-item:nth-child(1){
        left: 0;
        transition-delay: .1s;
    }
    .task-show>.task-item:nth-child(2){
        left: 0;
	}

	.task-hide>.task-item:nth-child(1){
		transition-delay: .1s;
	}
    .task-item-shadow{
        box-shadow: 0 0 .3rem #000 inset,0 0 .3rem #000;
    }
    .mark-ico>img{
        animation: shake 1s linear infinite alternate;
    }
    @keyframes shake {
        0%{
            transform: rotateZ(-5deg);
        }
        10%{
            transform: rotateZ(5deg);
        }
        20%{
            transform: rotateZ(0deg);
        }
    }
    .ticket-ico>img{
        animation: scale 1s linear infinite alternate;
    }
    @keyframes scale {
        to{
            transform: scale(1.15);
        }
    }
    .top>.direction{
        top: 0;
    }
    .bottom>.direction{
        bottom: 0;
    }
    .start>.direction{
        left: 0;
    }
    .end>.direction{
        right: 0;
    }
    .bottom .task-show,.bottom .task-hide{
        order: -1;
    }
</style>
<template>
    <!-- 悬浮活动 -->
    <div v-if="IS_HAVE_MARK||IS_HAVE_TICKET" class="position-absolute start-0 top-0 bottom-0 end-0">
        <div class="d-flex flex-column position-absolute direction">
            <!-- 开关 -->
            <div @click="isShowTask=!isShowTask" :class="switchClass" class="justify-content-center align-items-center rounded-circle border border-3 border-warning w-3rem h-3rem bg-dark bg-opacity-75 shadow hover-scale index-1">
                <i :class="[isShowTask?'bi-chevron-right':'bi-gift']" class="bi fs-3 lh-1 text-warning"></i>
            </div>
            <!-- 活动 -->
            <div :class="[isShowTask?'task-show':'task-hide']">
                <!-- 代券活动 -->
                <div v-if="IS_HAVE_TICKET" @click="showTaskPanel('ticket')" class="position-relative rounded-circle w-3rem h-3rem task-item bg-yellow border border-3 border-warning task-item-shadow ticket-ico my-2 index-1">
                    <img class="w-100 hover-scale" src="@/assets/images/common/ticket.png" alt="">
                    <i class="position-absolute bottom-0 start-0 end-0 text-primary fw-bold lh-1 fs-_6rem text-center text-shadow-white text-nowrap">每日送券</i>
                </div>
                <!-- 连中活动 -->
                <div v-if="IS_HAVE_MARK" @click="showTaskPanel('mark')" class="position-relative rounded-circle w-3rem h-3rem task-item bg-yellow border border-3 border-warning task-item-shadow mark-ico my-2 index-1">
                    <img class="w-100 hover-scale" src="@/assets/images/room/bac/mark.png" alt="">
                    <i class="position-absolute bottom-0 start-0 end-0 text-primary fw-bold lh-1 fs-_6rem text-center text-shadow-white text-nowrap">连中活动</i>
                </div>
            </div>

        </div>

        <div @click="showTaskPanel()" :class="{'position-fixed bg-dark bg-opacity-50 start-0 top-0 bottom-0 end-0 index-13':isShowMark||isShowTicket}">
            <task-mark @click.stop v-if="IS_HAVE_MARK" :is-show-panel="isShowMark" @close="isShowMark=false"></task-mark>
            <task-ticket @click.stop v-if="IS_HAVE_TICKET" :is-show-panel="isShowTicket" @close="isShowTicket=false"></task-ticket>
        </div>

    </div>
</template>
<script>
import {USER,IS_HAVE_MARK,IS_HAVE_TICKET} from "@/assets/js/config.js"
import taskTicket from "@/components/public/taskTicket.vue";
import taskMark from "@/components/public/taskMark.vue";
export default{
    components:{
        taskTicket,
        taskMark
    },
    props:{
        //是否显示所有活动任务图标
        isShowTask:{
            type:Boolean,
            default:false
        },
        //开关样式
        switchClass:{
            type:String,
            default:"d-flex"
        }
    },
    data(){
        return {
            IS_HAVE_MARK,
            IS_HAVE_TICKET,
            isShowTicket:false,//是否显示代券活动界面
            isShowMark:false,//是否显示连中活动界面
        }
    },
    methods: {
        /**
         * 打开任务主面板
         */
        showTaskPanel(type){
            //不需要开的都关闭
            this.isShowTicket=type=="ticket"?true:false;
            this.isShowMark=type=="mark"?true:false;
        }
    },
}
</script>